// Masifi (plan R1 Tarea 5, R1-RD): links de ayuda por marca. La instancia conserva los de upstream; una marca usa su
// documentación (BRAND_DOCS_URL) o ninguno (undefined → BaseSettingsHeader/QuickLinks ocultan el link). BRAND_KIND y
// BRAND_DOCS_URL los entrega el servidor en window.globalConfig (Masifi::Branding::Resolved#global_config_overrides).
export const masifiHelpUrl = (
  featureName,
  upstreamUrl,
  globalConfig = globalThis.window?.globalConfig
) => {
  const kind = globalConfig?.BRAND_KIND;
  if (!kind || kind === 'instance') return upstreamUrl;
  return globalConfig.BRAND_DOCS_URL || undefined;
};
